const Cabs = [
  {
    name: "Prasanth Cabs",
    phone: "7702096068",
    cars: [
      {
        id: 1,
        name: "Swift",
        capacity: 3,
        em_fac: 110,
      },
      {
        name: "WagonR",
        capacity: 3,
        id: 2,
        em_fac: 144,
      },
      {
        name: "Etios",
        capacity: 4,
        id: 3,
        em_fac: 138,
      },
      {
        name: "Innova",
        capacity: 6,
        id: 4,
        em_fac: 178,
      },
      ,
      {
        name: "Xylo",
        capacity: 7,
        id: 5,
        em_fac: 200,
      },
    ],
  },

  // {
  //   name: "BlaBla Cabs",
  //   phone: "998",
  //   cars: [
  //     {
  //       id: 1,
  //       name: "Swift",
  //       capacity: 3,
  //       em_fac: 110,
  //     },
  //     {
  //       name: "WagonR",
  //       capacity: 3,
  //       id: 2,
  //       em_fac: 144,
  //     },
  //     {
  //       name: "Etios",
  //       capacity: 4,
  //       id: 3,
  //       em_fac: 138,
  //     },
  //     {
  //       name: "Innova",
  //       capacity: 6,
  //       id: 4,
  //       em_fac: 178,
  //     },
  //     ,
  //     {
  //       name: "Xylo",
  //       capacity: 7,
  //       id: 5,
  //       em_fac: 200,
  //     },
  //   ],
  // },
  {
    name: "Reddy Cabs",
    phone: "9989654420",
    cars: [
      {
        id: 6,
        name: "Swift",
        capacity: 3,
        em_fac: 110,
      },
      {
        name: "WagonR",
        capacity: 3,
        id: 7,
        em_fac: 144,
      },
      {
        name: "Etios",
        capacity: 4,
        id: 8,
        em_fac: 138,
      },
      {
        name: "Innova",
        capacity: 6,
        id: 9,
        em_fac: 178,
      },
      ,
      {
        name: "Xylo",
        capacity: 7,
        id: 10,
        em_fac: 200,
      },
    ],
  },
];

export default Cabs;
